
// NATIVE 


// INSTALLED 

// CUSTOM 
import { useDispatch } from "react-redux";
import { AxiosAdapter } from "../commons/adapters";
import { closeSessionGlobal } from "../commons/utils";


const http = new AxiosAdapter();


export const getAllParametersDataCreateFormService = async() => {
   
    try {

        return await http.get<any>(`/v1/turnos-empelados/data-form-inputs`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getAllParametersDataCreateFormService ',error)
    }
}




export const createConfiguracionTurnoService = async(configuracionTurno:object, setPercentage:any) => {
   
    try {
        
        return await http.post<any>('/v1/turnos-empelados', configuracionTurno, setPercentage); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('createConfiguracionTurnoService ',error);

    }
}



export const getConfigShiftEmployeesService = async() => {
   
    try {
        
        return await http.get<any>(`/v1/turnos-empelados`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getConfigShiftEmployeesService ',error);

    }
}